const varintBtn = document.querySelectorAll(".product__variant label");
if (varintBtn !== undefined) {
  varintBtn.forEach(function (el) {
    el.addEventListener("click", function () {
      const formVariantId = document.querySelector(
        '[data-type="add-to-cart-form"] [name="id"]'
      );
      const productPrice = document.querySelector(
        ".product__info-container .price-item--regular"
      );
      const variantPrice =
        el.previousElementSibling.getAttribute("data-variant-price");
      const variantId =
        el.previousElementSibling.getAttribute("data-variant-id");
      if (variantPrice && variantId && formVariantId && productPrice) {
        productPrice.innerHTML = variantPrice;
        formVariantId.value = variantId;
      }

      changeVariantMeta(variantId);
    });
  });
}

const changeVariantMeta = () => {
  setTimeout(() => {
    const variantDynamicMeta = document.querySelectorAll(".variant-dynamic-height-meta");
    const variantsJson = document.getElementById("variants_meta") ? JSON.parse(document.getElementById("variants_meta").innerText) : null;
    const currentVariantId = document.querySelector('.product-container .product-form [name="id"]');
    const dynamicDiscounts = document.querySelector('.product__variant--dynamic');

    if (variantsJson && currentVariantId) {
      const currentVariant = variantsJson.variants.find((variant) => variant.id === Number(currentVariantId.value));

      /* change height metafield value */
      if (variantDynamicMeta.length) {
        let metaText = variantsJson?.product_height || "";

        if (currentVariant && currentVariant?.height) {
          metaText = currentVariant.height;
        }

        if (metaText) {
          variantDynamicMeta.forEach((el) => {
            el.innerText = metaText;
          });
        }
      }
      /* end change height metafield value */

      /* change badge value */
      const lowerCaseOptions = variantsJson.options.map(opt => opt.toLowerCase());
      const hasRequiredOptions = lowerCaseOptions.includes("size") && lowerCaseOptions.includes("quantity");

      if (dynamicDiscounts && currentVariant && hasRequiredOptions) {
        const quantityElements = dynamicDiscounts.querySelectorAll('.option-type--quantity');
        const sizeOption = lowerCaseOptions[0] === "size" ? currentVariant.option1 : currentVariant.option2;
        const quantityOption = lowerCaseOptions[0] === "size" ? currentVariant.option2 : currentVariant.option1;

        quantityElements.forEach(el => {
          const badge = el.querySelector(".variant-badge");
          let variant;

          if (badge) badge.remove();

          if (el.getAttribute('data-option-name') === quantityOption.toLowerCase()) {
            variant = currentVariant;
          } else {
            variant = variantsJson.variants.find(item => {
              const size = lowerCaseOptions[0] === "size" ? item.option1 : item.option2;
              const quantity = lowerCaseOptions[0] === "size" ? item.option2 : item.option1;

              if (size.toLowerCase() === sizeOption.toLowerCase() && quantity.toLowerCase() === el.getAttribute('data-option-name')) {
                return item;
              }
            })
          }

          if (variant) {
            const discount = variant?.compare_at_price ? (((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100).toFixed(0) : 0;

            if (discount > 0) {
              el.insertAdjacentHTML('beforeend', `
              <span class="variant-badge" 
                style="${variant.badge_text_color ? 'color: ' + variant.badge_text_color + ';' : ''}">
                ${discount}% Off
              </span>`)
            }
          }
        })
      }
      /* end change badge value */
    }
  }, 0);
};

document.addEventListener("DOMContentLoaded", () => {
  changeVariantMeta();
});
